exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir=ltr] ._1IQ65UugwuADqX2VwvgZNK{margin:4px 6px 0 0}html[dir=rtl] ._1IQ65UugwuADqX2VwvgZNK{margin:4px 0 0 6px}", ""]);

// exports
exports.locals = {
	"groupFacepilePersona": "_1IQ65UugwuADqX2VwvgZNK"
};